<div class="dashboard-card">
  <div class="card-header">
    <h4 class="card-title">Low Stock</h4>
  </div>
  <div class="card-content">
    <div *ngIf="isLoadingLowStock" class="card-loading">
      <div class="loading-spinner"></div>
      <span>Loading low stock data...</span>
    </div>
    <div *ngIf="!isLoadingLowStock && (!lowStockData || lowStockData.length === 0)" class="empty-state-message">
      <span>No products are low in stock for the selected date range.</span>
    </div>
    <div *ngIf="!isLoadingLowStock && lowStockData && lowStockData.length > 0" class="table-responsive">
      <table class="table low-stock-table">
        <thead>
          <tr>
            <th>Product Name</th>
            <th class="min-qty">Minimum Quantity</th>
            <th class="avail-stock">Available Stock</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of lowStockData">
            <td>{{ item.product_name }}</td>
            <td class="min-qty">{{ item.minimum_quantity }}</td>
            <td class="avail-stock">{{ item.stock_count }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div> 